export const OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT = '/template-print';

export const OUTBOUND_PRINT_TEMPLATE_ROUTES = {
  PRINT: OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT,
  INVOICE: `${OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT}/invoice`,
  INVOICE_PACK: `${OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT}/invoice-pack`,
  INVOICE_ESP: `${OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT}/invoice-esp`,
  TTF: `${OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT}/ttf`,
  SHIP_LABEL: `${OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT}/ship-label`,
  DELIVERY_NOTE: `${OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT}/delivery-note`,
  WILDCARD: `${OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT}/*`,
} as const;
